import { render } from "./PriceForm.vue?vue&type=template&id=fd6e9638&scoped=true"
import script from "./PriceForm.vue?vue&type=script&lang=js"
export * from "./PriceForm.vue?vue&type=script&lang=js"

import "./PriceForm.vue?vue&type=style&index=0&id=fd6e9638&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd6e9638"]])

export default __exports__